import ScenarioActionType from '@/store/modules/scenario/scenario.type'
import { CardService, StepService } from '@/services/bot.service'
import AppService from '@/services/app.service'

const types = ScenarioActionType

const StepStoreMixin = {
    [types.CREATE_STEP] (context, data) {
        let {
            commit,
            state
        } = context
        commit(types.ADD_SAVING_COUNT, 1)
        let scenario = state.mapCodeToScenario[data.scenario_code]
        return StepService.create(
            scenario.app_code,
            scenario.code,
            data
        ).then(result => {
            let step = result.data
            step.config = step.config || []
            step.cards = []
            state.mapCodeToStep[step.code] = step
            state.mapNameToStep[step.name] = step
            state.mapCodeToScenario[step.scenario_code].steps.push(step)
            state.stepList.push(step)
            if (data.data) {
                CardService.search(
                    scenario.app_code,
                    scenario.code,
                    step.code
                ).then(result => {
                    let cards = result.data
                    cards.forEach(card => {
                        card.config = JSON.parse(card.config)
                        state.mapCodeToCard[card.code] = card
                    })
                    state.cardList.push(cards)
                    step.cards = cards
                }).finally(() => {
                    commit(types.SHOULD_UPDATE_GRAPH)
                })
            }
            commit(types.SHOULD_UPDATE_GRAPH)
            return step
        }).finally(() => {
            commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.UPDATE_STEP] (context, step) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        let scenario = context.state.mapCodeToScenario[step.scenario_code]
        return StepService.update(
            scenario.app_code,
            scenario.code,
            step.code,
            step
        ).then(
            result => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                let oldStep = context.state.mapCodeToStep[step.code]
                let newStep = result.data
                let cardList = context.state.cardList
                for (let card of cardList) {
                    if (card.config.buttons) {
                        for (let button of card.config.buttons) {
                            if (button.payload) {
                                let split = button.payload.split('#')
                                if (split[0] === oldStep.name) {
                                    button.payload = newStep.name + '#' + split[1]
                                }
                            }
                        }
                    }
                }
                context.state.mapNameToStep[oldStep.name] = null
                context.state.mapNameToStep[newStep.name] = oldStep
                Object.assign(oldStep, newStep)
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return step
            },
            e => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                return Promise.reject(e)
            }
        )
    },
    [types.DELETE_STEP] (context, step) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        let scenario = context.state.mapCodeToScenario[step.scenario_code]
        AppService.showLoading()
        return StepService.delete(
            scenario.app_code,
            scenario.code,
            step.code
        ).then(
            result => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                context.state.stepList.splice(
                    context.state.stepList.indexOf(step),
                    1
                )
                scenario.steps.splice(
                    scenario.steps.indexOf(step),
                    1
                )
                context.state.mapCodeToStep[step.code] = null
                context.state.mapNameToStep[step.name] = null
                if (context.state.activeStepCode === step.code) {
                    context.dispatch(types.ACTIVE_DATA, {
                        activeScenarioCode: context.state.activeScenarioCode
                    })
                } else {
                    context.dispatch(types.SHOULD_UPDATE_GRAPH)
                }
                return result.data
            },
            e => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                return Promise.reject(e)
            }
        ).finally(AppService.hideLoading)
    },
    [types.POSITION_STEP] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        return StepService.updatePosition(
            data.botCode,
            data.targetScenarioCode,
            data.stepCode,
            data.stepCodeList
        ).then(
            result => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return result.data
            },
            e => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                return Promise.reject(e)
            }
        )
    }
}

export default StepStoreMixin
